import {useLayoutEffect} from 'react';
import {isBrowser} from '@shopify/hydrogen';

export function useScrollFreeze() {
  useLayoutEffect(() => {
    if (!isBrowser()) return;

    const original = window.getComputedStyle(document.documentElement).overflow;
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.documentElement.style.overflow = original;
    };
  }, [isBrowser()]);
}
